import { AuthConstraintRoute } from '@sharelo-lib/auth';
import { ShareloSeo } from '@sharelo-lib/seo';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

const ContactsPageContainer = dynamic(
  () =>
    import('@sharelo-lib/contacts-pages').then(
      (module) => module.ContactsPageContainer,
    ),
  { ssr: false },
);

const ContactsPage = () => {
  const { t } = useTranslation('common');
  return (
    <AuthConstraintRoute>
      <ShareloSeo title={t('seo.title.contacts')} />
      <ContactsPageContainer />
    </AuthConstraintRoute>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default ContactsPage;
